import { render, staticRenderFns } from "./ReclaimRequests.vue?vue&type=template&id=2eb6e15b&scoped=true&"
import script from "./ReclaimRequests.vue?vue&type=script&lang=js&"
export * from "./ReclaimRequests.vue?vue&type=script&lang=js&"
import style0 from "./ReclaimRequests.vue?vue&type=style&index=0&id=2eb6e15b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb6e15b",
  null
  
)

export default component.exports